"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryBody = void 0;
const tslib_1 = require("tslib");
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const lambda_1 = require("../lambda");
const TypeHelpers_1 = require("../TypeHelpers");
const queryPartBuilderFns_1 = require("./queryPartBuilderFns");
const debug = lambda_1.DEBUG_OVERRIDE || (lambda_1.NOT_LAMBDA && false);
const dyn = config_1.default.aws.dynamoDB;
// TODO getQueryBody needs to deal with where filter expresssion does not work when converted to key expression: err: Error: Invalid operator used in KeyConditionExpression: <>
// {
//     key: dyn.sKey, predicate: ComparisonType.NOT_EQUALS, value: contextObject.sk
// }
/**
 * @function getQueryBody produces a DocumentClient.QueryInput from iotv system types. To use to get items by type set the contextObject of params in the form { sk: 'TargetType'}
 * @param param0
 * @returns
 */
const getQueryBody = ({ contextObject, adjacencyType, ExclusiveStartKey, limit = 500, groupSetOperation = iotv_v3_types_1.LogicalOperatorType.AND, filterGroups, TableName = dyn.tableName }) => {
    const keyLookUp = {
        [iotv_v3_types_1.AdjacentType.PARENT]: {
            hashKey: dyn.sKey,
            sortKey: dyn.pKey,
            hashKeyValue: contextObject?.sk ?? 'never',
            IndexName: dyn.gsiName,
        },
        [iotv_v3_types_1.AdjacentType.CHILD]: {
            hashKey: dyn.pKey,
            sortKey: dyn.sKey,
            hashKeyValue: contextObject?.sk,
            IndexName: undefined,
        },
        [iotv_v3_types_1.AdjacentType.SUBJECT]: {
            hashKey: dyn.typesiPrimaryKey,
            sortKey: dyn.typesiSortKey,
            hashKeyValue: contextObject ? (0, TypeHelpers_1.getZombieInstanceFromPrimaryKey)(contextObject.sk)?.type : '',
            IndexName: dyn.typesiName,
        },
    };
    if (!contextObject) {
        adjacencyType = iotv_v3_types_1.AdjacentType.SUBJECT;
    }
    const { hashKey, hashKeyValue, IndexName } = keyLookUp[adjacencyType];
    const hashKeyNameSub = (0, queryPartBuilderFns_1.getKeyNameSub)(hashKey);
    const hashKeyValueSub = (0, queryPartBuilderFns_1.getKeyValueSub)(hashKey);
    const params = {
        TableName,
        IndexName,
        ExclusiveStartKey,
        ExpressionAttributeValues: {
            [hashKeyValueSub]: hashKeyValue,
        },
        Limit: limit,
        ExpressionAttributeNames: {
            [hashKeyNameSub]: hashKey,
        },
        KeyConditionExpression: `${hashKeyNameSub} = ${hashKeyValueSub}`,
        FilterExpression: undefined,
    };
    /** 2024 03 - filter to nodes only if subject  */
    if (adjacencyType === iotv_v3_types_1.AdjacentType.SUBJECT) {
        const pKeySub = (0, queryPartBuilderFns_1.getKeyNameSub)(dyn.pKey);
        const sKeySub = (0, queryPartBuilderFns_1.getKeyNameSub)(dyn.sKey);
        params.ExpressionAttributeNames[pKeySub] = dyn.pKey;
        params.ExpressionAttributeNames[sKeySub] = dyn.sKey;
        params.FilterExpression = `${pKeySub} = ${sKeySub}`;
    }
    if (filterGroups) {
        (0, queryPartBuilderFns_1.addFilterPartsToParams)({ params, groupSetOperation, filterGroups, adjacencyType, keyLookUp });
    }
    return params;
};
exports.getQueryBody = getQueryBody;
